import { useEffect, useState } from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../components/ui/select";
import { Option } from "../../interface/Option";
import { SayanAxiosInstance } from "../../Network/SayanAxiosInstance";

const ListOfCustomActivities = ({
  clear,
  onChange,
  defaultValue,
  selectedActivityType,
  isValid,
}: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");

  // Load options when selectedActivityType changes
  useEffect(() => {
    const fetchOptions = async () => {
      if (!selectedActivityType) {
        setOptions([]);
        return;
      }
      try {
        const response = await SayanAxiosInstance.put(
          `getAllActivity/${selectedActivityType}`
        );
        const data = response.data;

        const newOptions: Option[] = data.map((item: any) => ({
          value: item,
          label: item.replace(" , ", " |"),
        }));

        setOptions(newOptions);
      } catch (error) {
        console.error("Error loading activities:", error);
      }
    };

    fetchOptions();
  }, [selectedActivityType]);

  // Clear selected option when clear flag is set
  useEffect(() => {
    if (clear) {
      setSelectedOption(null);
    }
  }, [clear]);

  // Set default value
  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      setSelectedOption(String(defaultValue[0]?.value)); 
    }
  }, [defaultValue]);

  const handleChange = (value: string) => {
    setSelectedOption(value);
  
    const selected = options.find((o) => String(o.value) === value);
    onChange(selected ? [selected] : []); 
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  
  const filteredOptions =
    searchQuery.length >= 3
      ? options.filter((option) =>
          option.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : options; 

  const customTriggerClass = `w-full ${isValid ? "" : "border-red-500"}`;

  return (
    <div>
      <Select onValueChange={(value) => handleChange(value)} value={selectedOption || ""}>
        <SelectTrigger className={customTriggerClass}>
          <SelectValue
            placeholder={
              selectedOption
                ? options.find((option) => option.value === selectedOption)
                    ?.label || "Select activity..."
                : "Select activity..."
            }
          />
        </SelectTrigger>
        <SelectContent>
          <div className="p-2">
            <input
              type="text"
              placeholder="Search activities..."
              value={searchQuery}
              onChange={handleSearch}
              className="w-full px-2 py-1 border border-gray-300 rounded"
            />
          </div>
          {searchQuery.length < 3 ? (
            <div className="p-4 text-gray-500">
              Type at least 3 characters to search...
            </div>
          ) : filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <SelectItem
                key={option.value}
                value={String(option.value)}
                onClick={() => handleChange(String(option.value))} 
              >
                <span
                  className={`${
                    selectedOption === String(option.value)
                      ? "font-bold text-blue-500"
                      : ""
                  }`}
                >
                  {option.label}
                </span>
              </SelectItem>
            ))
          ) : (
            <div className="p-4 text-gray-500">No options found</div>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ListOfCustomActivities;


